import React, {useState, useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import {Badge} from 'primereact/badge';
import {Button} from "primereact/button";
import {Dialog} from 'primereact/dialog';
import axios from "axios";

const ImportListComponent = (props) => {

  const {t} = props;
  const {module} = useParams();
  const [type, setType] = useState('');
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const rows = Number(process.env.REACT_APP_LIST_ROW_DEFAULT) || 25;
  const dt = useRef(null);
  const [statusDict, setStatusDict] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);
  const [details, setDetails] = useState({visible: false, loading: false, rows: [], errors: []});
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'created_at',
    sortOrder: -1,
  });
  const authHeaders = {
    'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
    'App-Network': localStorage.getItem("networkId")
  };
  const loadLazyData = () => {
    let active = true;
    setLoading(true);
    const query = window.App.transformQueryParams(lazyParams);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/import-state/" + type + query,
      {headers: authHeaders})
      .then(response => {
        if (!active) return;
        setTotalRecords(response.data.data.total_item_count);
        setImports(response.data.data.items);
      })
      .catch(error => {
        if (active) window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  };
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event, first: 0, page: 0};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setLazyParams(prev => ({...prev, rows: e.value, first: 0, page: 0}))}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>

  //     </React.Fragment>
  //   );
  // }

  const getStatusSeverity = (statusRaw) => {
    const s = (statusRaw ?? '').toString().trim().toLowerCase();
    if (s === 'done') return 'success';
    if (s === 'processing') return 'info';
    if (s === 'pending') return 'warning';
    return 'danger';
  };

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleRetry = (rowData) => {
    if (!type || !rowData?.id) {
      return;
    }
    setLoading(true);
    axios.post(
      process.env.REACT_APP_API_HOST + '/api/v2/import-state/' + type + '/' + rowData.id + '/retry',
      {},
      {
        headers: authHeaders
      }
    )
      .then(() => {
        window.App.toastShow('success', t('importRestartQueued'));
        handleRefresh();
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const showDetails = rowData => {
    setDetails({visible: true, loading: true, rows: [], errors: []});
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/import-state/' + type + '/' + rowData.id, {headers: authHeaders})
      .then(response => {
        const data = response.data.data || {};
        setDetails({visible: true, loading: false, rows: data.rows || [], errors: data.error_log || []});
      })
      .catch(error => {
        setDetails(current => ({...current, loading: false}));
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  };

  const loadStatusDict = () => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dictionary/import-status", {
      headers: authHeaders
    })
      .then(response => {
        const data = response?.data?.data;
        if (Array.isArray(data)) {
          const dict = data.reduce((acc, it) => {
            const k = (it?.key ?? '').toString().trim();
            const v = (it?.value ?? '').toString();
            if (k && v) {
              acc[k] = v;
              acc[k.toLowerCase()] = v;
            }
            return acc;
          }, {});
          setStatusDict(dict);
          return;
        }
        if (Array.isArray(data?.items)) {
          const dict = data.items.reduce((acc, it) => {
            const k = (it?.key ?? it?.code ?? it?.id ?? '').toString().trim();
            const v = (it?.value ?? it?.label ?? it?.name ?? '').toString();
            if (k && v) {
              acc[k] = v;
              acc[k.toLowerCase()] = v;
            }
            return acc;
          }, {});
          setStatusDict(dict);
          return;
        }
        setStatusDict({});
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setStatusDict({});
      });
  };

  useEffect(() => {
    if (!type) {
      if (props.importType) {
        setType(props.importType);
        return;
      }
      if (module === 'crm') {
        setType('crm_action');
        return;
      }
      if (module === 'procurement') {
        setType('purchase_order_request');
        return;
      }
      if (module === 'inventory') {
        setType('material');
        return;
      }
    }
    if (type.length > 0) {
      return loadLazyData();
    }
  }, [lazyParams, window.App.state.rerenderImportList, type, refreshKey]);

  useEffect(() => {
    loadStatusDict();
  }, []);

  return (
    <>
      {!props.isClosed && (
        <div style={{ width: '100%', textAlign: 'right', marginBottom: '0.5rem' }}>
          <Button
            type="button"
            icon="pi pi-refresh"
            label={t('refresh')}
            className="p-button-secondary p-button-sm"
            tooltip={t('refresh')}
            tooltipOptions={{ position: 'left' }}
            loading={loading}
            onClick={handleRefresh}
          />
        </div>
      )}
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={imports} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={lazyParams.rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
      >
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
                  return (
                    <>{window.App.formatDateValue(rowData.created_at)}</>
                  )
                }}></Column>
        <Column field="status" header={t('columnStatus2')} sortable
                body={(rowData) => {
                  const raw = (rowData?.status ?? '').toString().trim();
                  const label = statusDict[raw] || statusDict[raw.toLowerCase()];
                   return (
                    <>
                      <div className="p-text-left">
                        <Badge value={label} severity={getStatusSeverity(raw)} />

                        {['pending', 'processing'].includes(raw.toLowerCase()) && (
                          <Button
                            type="button"
                            icon="pi pi-refresh"
                            className="p-button-secondary p-ml-2"
                            tooltip={t('importRestartProcessing')}
                            aria-label={t('importRestartProcessing')}
                            disabled={loading}
                            tooltipOptions={{ position: 'left' }}
                            onClick={() => handleRetry(rowData)}
                            style={{
                              width: '1.6rem',
                              height: '1.6rem',
                              padding: 0,
                              minWidth: '1.8rem'
                            }}
                          />
                        )}
                      </div>
                    </>
                  );
                }}
        ></Column>
        <Column field="total_rows" header={t('columnTotalRows')} sortable></Column>
        <Column field="processed_rows" header={t('columnProcessedRows')} sortable></Column>
        <Column body={rowData => <Button type="button" icon="pi pi-eye" className="p-button-text p-button-sm" label={t('details')} onClick={() => showDetails(rowData)}/>}/>
        {/*<Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>*/}
      </DataTable>
      <Dialog visible={details.visible} modal style={{width: 'min(1000px, 96vw)'}} header={t('importDetails')} onHide={() => setDetails({visible: false, loading: false, rows: [], errors: []})}>
        {details.errors.length > 0 && <div className="p-message p-message-error p-mb-3"><div className="p-message-wrapper"><ul>{details.errors.map((error, index) => <li key={index}>{error}</li>)}</ul></div></div>}
        <DataTable value={details.rows} loading={details.loading} emptyMessage={t('noResults')} responsiveLayout="scroll" stripedRows>
          <Column field="number_of_rows" header={t('columnRow')}/>
          <Column field="status" header={t('columnStatus2')}/>
          <Column field="error_message" header={t('importResult')}/>
        </DataTable>
      </Dialog>
    </>
  )
}
export default withTranslation('common')(ImportListComponent);
